import React, { useState } from "react";
import Terms from "./terms";
import Warranty from "./warranty";
import Affiliate from "../affiliate";
import { Switch, Slider, Text, TextArea } from "components/fields";
import { Custom, Discount, Webhook } from "../index";
import { MoreInfo } from "../../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import { Tooltip } from "@paylixecommerce/shared/components";
import useMobile from "../../../../../../../../hooks/useMobile";

import "./index.scss";


export default ({ form, volumeDiscounts, gateways, setVolumeDiscounts, customFields, setCustomFields, webhooks, setWebhooks }) => {

	const [customModal, setCustomModal] = useState(false);
	const [volumeDiscountsModal, setVolumeDiscountsModal] = useState(false);
	const [webHookModal, setWebHookModal] = useState(false);

	const isMobile = useMobile();

	const showBlockVPN = (gateways.PAYPAL && gateways.PAYPAL === true) || (gateways.STRIPE && gateways.STRIPE === true);

	return (
		<div className="product-form-main-back pb-3" style={{ overflow: isMobile ? "unset" : "hidden" }}>

			<div>

				<div className="d-flex flex-wrap w-100">
					<Switch withBorder name="unlisted" label="Unlisted" left {...form} note="The product wont be displayed on your Shop, but can still be accessed via direct URL." />
					<Switch withBorder name="private" {...form} label="Private" left note="This product will be removed from your shop and customers will not be able to use the direct link either." />
					{showBlockVPN ? <Switch withBorder name="block_vpn_proxies" {...form} left label="Block VPNs/Proxies" note="Customers using a VPN or a Proxy will be blocked from purchasing your products if using a non-crypto payment method." /> : null}
					<Switch withBorder name="on_hold" {...form} label="On Hold" left note="If checked, this product will be displayed on your shop but customers won't be able to purchase it." />
				</div>

				<div className="w-100">
					{(form.values.type === "FILE" || form.values.subtype === "FILE") ?
						<Switch name="watermark_enabled" {...form} label="Watermark Custom Text " note="Enable the watermark feature to add a customisable text over PDFs and Images that your customers download." left
								withBorder={!form.values.watermark_enabled}
						/>
					: null}

					{form.values.watermark_enabled ?
						<div className="mb-4 mt-3" style={{ borderBottom: "1px solid var(--black1)" }}>
							<Text name="watermark_text" placeholder="Custom watermark for this product" {...form} note={<>
								You can use custom variables on the watermark text. <br/>
								Any field on the invoice object is available, for example, <b>{`{{`}customer_email{`}}`}</b> will be automatically replaced with the customer’s email. <br/>
								More details on the invoice object can be found at <a href="https://developers.paylix.gg" target="_blank">developers.paylix.gg</a>.
							</>} noteUnder />
						</div>
						: null
					}
				</div>

				<div className="w-100">
					<Switch name="redirect_enabled" {...form} label="Redirect Link" left note="Your customers will be redirected to this link after the invoice has been paid."
							withBorder={form.values.redirect_enabled ? false : true}
					/>

					{form.values.redirect_enabled ?
						<div className="mb-4 mt-3" style={{ borderBottom: "1px solid var(--black1)" }}>
							<Text name="redirect_link" placeholder="https://google.com" {...form}
								note={<>
									You can use custom variables on the redirect link. <br/>
									Any field on the invoice object is available, for example, <b>{`{{`}uniqid{`}}`}</b> will be automatically replaced with the customer’s invoice id. <br/>
									More details on the invoice object can be found at <a href="https://developers.paylix.gg" target="_blank">developers.paylix.gg</a>.
								</>}
							  noteUnder
							/>
						</div>
						: null
					}
				</div>

				<div className="w-100">
					<Terms form={form} />
				</div>

				<div className="w-100">
					<Warranty form={form} />
				</div>

				<div className="w-100">
					<Switch name="delivery_text_enabled" {...form} label="Delivery Text" wrapperClassName="mb-3" note="When the user pays and receives your product, he will also see this text." left
							withBorder={form.values.delivery_text_enabled ? false : true}
					/>

					{form.values.delivery_text_enabled ?
						<div className="mb-4" style={{ borderBottom: "1px solid var(--black1)" }}>
							<TextArea
								rows={3}
								label=""
								tooltip=""
								placeholder="E.g: Thanks for purchasing, use our new coupon DISCOUNT#Paylix for another 30% OFF on your next purchase!"
								name="delivery_text"
								{...form}
							/>
						</div>
						: null
					}
				</div>

				<Affiliate form={form} />

				<div>
					<Slider
						label={
							<div className="d-flex flex-column">
								<span className="d-flex align-items-start">
									<span>Maximum Fraud Detection Score</span>
									<span className="ml-1">
										<Tooltip tooltipText="The maximum risk level of the buyer. The higher this value is the less strict the check will be. The suggested value is between 75 and 85. In order to block suspicious and high risk transactions set this value to 75, to block only high risk transactions set it to 85." name="risk">
											<MoreInfo />
										</Tooltip>
									</span>
								</span>
								<span className="paylixecommerce-note mt-1">Please note that setting this to zero will block every sale.</span>
							</div>
						}
						wrapperClassName="pl-0 pr-0"
						styles={{ height: "3rem" }}
						domain={[0, 100]} ticks={[0, 50, 100]}
						name="max_risk_level"
						{...form}
					/>
				</div>

			</div>

			<div style={{ borderBottom: "1px solid var(--black1)", height: 1 }} className="w-100 mt-4 mb-4" />

			<Discount
				currency={typeof form.values.currency === "string" ? form.values.currency : form.values.currency.value}
				setModal={(value) => setVolumeDiscountsModal(value)}
				modal={volumeDiscountsModal}
				fields={volumeDiscounts}
				updateFields={setVolumeDiscounts}
				form={form}
			/>

			<Custom
				setModal={(value) => setCustomModal(value)}
				modal={customModal}
				fields={customFields}
				updateFields={setCustomFields}
			/>

			<Webhook
				setModal={(value) => setWebHookModal(value)}
				modal={webHookModal}
				fields={webhooks}
				updateFields={setWebhooks}
			/>

		</div>
	)
}